import React, { useEffect } from 'react';
import { DesignTokenSizeEnum } from '@volkswagen-onehub/components-core';

export enum ViewportType {
  'DESKTOP' = 'desktop',
  'TABLET' = 'tablet',
  'MOBILE' = 'mobile',
}

export const getDynamicSize = (
  viewport: ViewportType,
  mobile: DesignTokenSizeEnum,
  tablet?: DesignTokenSizeEnum,
  desktop?: DesignTokenSizeEnum
): DesignTokenSizeEnum => {
  switch (viewport) {
    case ViewportType.DESKTOP:
      return desktop ?? tablet ?? mobile;
    case ViewportType.TABLET:
      return tablet ?? mobile;
    case ViewportType.MOBILE:
    default:
      return mobile;
  }
};

export function useViewport(
  mobile: number,
  tablet: number,
  defaultViewport: ViewportType = ViewportType.MOBILE
): ViewportType {
  const [viewport, setViewport] = React.useState(defaultViewport);

  const getViewType = (width: number) => {
    if (width >= 0 && width < mobile) return ViewportType.MOBILE;
    if (width >= mobile && width < tablet) return ViewportType.TABLET;
    return ViewportType.DESKTOP;
  };

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleResize = () => {
      setViewport(getViewType(window.innerWidth));
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [mobile, tablet]);

  return viewport;
}
